import React, { useMemo } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import styles from './result.module.scss';

const ResultCell = ({ data, value }: Partial<ICellRendererParams>) => {
  const isAbandoned = useMemo(() => data?.status === 'ABANDONED', [data?.status]);

  const style = useMemo(() => {
    if (!isAbandoned) {
      return value ? styles.resultWon : styles.resultLost;
    }

    return '';
  }, [isAbandoned, value]);

  return (
    <span className={style}>
      {isAbandoned ? '-' : <strong>{value === true ? 'Won' : 'Lost'}</strong>}
    </span>
  );
};

export { ResultCell };
